module.exports = __webpack_public_path__ + "static/media/24.e73c732.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/24.wav
// module id = QTn/
// module chunks = 0